import React, { useEffect, useState, useRef } from 'react';  
import { useSpring, animated } from 'react-spring';  
import axios from 'axios';  
import homeScreen from '../assets/images/home-screen.webp';  
import homeButton from '../assets/images/home-button.webp';  
import homeButtonHover from '../assets/images/home-button-hover.webp';  
import homeWalletCount from '../assets/images/home-wallet-count.webp'  
import litepaperButton1 from '../assets/images/litepaper-button-1.webp';  
import litepaperButton1Hover from '../assets/images/litepaper-button-1-hover.webp';  
import litepaperButton2 from '../assets/images/litepaper-button-2.webp';  
import litepaperButton2Hover from '../assets/images/litepaper-button-2-hover.webp';  
import litepaperDashboardBottom from '../assets/images/litepaper-dashboard-bottom.webp';  
import litepaperDashboardTop from '../assets/images/litepaper-dashboard-top.webp';  
import litepaperTextbox from '../assets/images/litepaper-textbox.webp';  
import litepaperMoon from '../assets/images/litepaper-moon.webp';  
import iconDiscord from '../assets/images/icon-discord.webp';  
import iconMedium from '../assets/images/icon-medium.webp';  
import iconTelegram from '../assets/images/icon-telegram.webp';  
import iconX from '../assets/images/icon-x.webp';  
import allAboardCandypoint from '../assets/images/all-aboard-candypoint.webp';  
import allAboardScreen3 from '../assets/images/all-aboard-screen-3.webp';  
import allAboardMoon from '../assets/images/all-aboard-moon.webp';  
import allAboardHandLeft from '../assets/images/all-aboard-console-hand-left.webp';  
import allAboardHandRight from '../assets/images/all-aboard-console-hand-right.webp';  
import logoIcandy from '../assets/images/logo-icandy.webp';  
import logoZksync from '../assets/images/logo-zksync.webp';  
import supportbyWemix from '../assets/images/support-wemix.webp';  
import supportbyAnimoca from '../assets/images/support-animoca.webp';  
import supportbySpartan from '../assets/images/support-spartan.webp';  
import supportbyPerlone from '../assets/images/support-perlone.webp';  
import supportbyPresto from '../assets/images/support-presto.webp';  
import supportbyFlowdesk from '../assets/images/support-flowdesk.webp';  
import supportbyLecca from '../assets/images/support-lecca.webp';  
import supportbyEfficientFrontier from '../assets/images/support-efficientfrontier.webp';  
import supportbyPrometheuz from '../assets/images/support-prometheuz.webp';  
import partnerGamecenter from '../assets/images/partner-gamecenter.webp';  
import swipeBanner1 from '../assets/images/swipe-banner-1.webp';  
import swipeBanner3 from '../assets/images/swipe-banner-3.webp';  
import { Swiper, SwiperSlide } from 'swiper/react';  
import 'swiper/css';  
import 'swiper/css/pagination';  
import 'swiper/css/navigation';  
import { Autoplay, Navigation } from 'swiper/modules';  
  
function AnimatedNumber({ n }) {  
    const prevN = useRef(n);  
    const { number } = useSpring({  
        from: { number: prevN.current },  
        to: { number: n },  
        config: {  
            duration: 1000,  
            easing: t => t * (2 - t),  
        },  
        onRest: () => {  
            prevN.current = n;  
        },  
    });  
    return <animated.span>{number.to((n) => Math.floor(n).toLocaleString())}</animated.span>;  
}  
  
export default function Home() {  
  
    const [currentScreen, setCurrentScreen] = useState('1');  
    const [totalWallets, setTotalWallets] = useState(0);  
  
  
    async function sendRequest(data, url, method = "post", params = null) {  
        const config = {  
            method,  
            url,  
            headers: {  
                "Content-Type": "application/json",  
            },  
            data: JSON.stringify(data),  
        };  
        if (params) config.params = params;  
        return await axios.request(config).catch(function (error) {  
            if (error.response) {  
                return error.response;  
            } else {  
                return error;  
            }  
        });  
    }  
  
    useEffect(() => {  
        const fetchTotalWallets = async () => {  
            try {  
                const response = await sendRequest(  
                    { action: "getTotalUsers" },  
                    `${process.env.REACT_APP_API_URL}`  
                );  
  
                if (response.status === 200 && response.data) {  
                    setTotalWallets(response.data.data);  
                }  
            } catch (error) {  
                console.error("Error fetching total wallets:", error);  
            }  
        };  
  
        fetchTotalWallets();  
  
        const intervalId = setInterval(fetchTotalWallets, 20000);  
  
        return () => clearInterval(intervalId);  
    }, []);  
  
    const social = [  
        {  
            img: iconDiscord,  
            link: 'https://discord.com/invite/zkcandy'  
        },  
        {  
            img: iconX,  
            link: 'https://x.com/ZKcandyHQ'  
        },  
        {  
            img: iconTelegram,  
            link: 'https://t.me/zkcandy'  
        },  
        {  
            img: iconMedium,  
            link: 'https://zkcandy.medium.com/'  
        },  
    ]  
  
    return (  
        <div className='zkcandy'>  
            <main>  
                <section id='homepage' className='relative flex flex-rows xl:items-end'>  
                    <div className='home-screen lg:relative xl:max-w-[2000px] w-full mx-auto '>  
                        <img src={homeScreen} alt='ZKcandy Monitor' />  
  
                        <div className='network-status absolute xl:bottom-[30%] xl:left-[auto] xl:top-[auto] xl:right-[10%] left-[50%] translate-x-[-50%] top-[4rem] no-wrap'>  
                            <div className='text-primary font-black  text-[1rem] whitespace-nowrap uppercase'>  
                                Mainnet Status: Online  
                            </div>  
                        </div>  
                        <div className='screen-text absolute -translate-x-[50%] -translate-y-[50%] left-[50%] xl:top-[40%] top-[55%] w-[100%]'>  
                            <div className="counter text-center relative mb-5 opacity-80">  
                                <img className='m-auto 2xl:max-w-[800px] max-w-[400px] w-[80%] absolute -translate-x-[50%] -translate-y-[50%] left-[50%] top-[50%]' src={homeWalletCount} alt="Wallet Count" />  
                                <div className="wallet-counts 2xl:text-[8rem] md:text-[4rem] text-[3rem] text-[#f643ff]">  
                                    <AnimatedNumber n={totalWallets} />  
                                </div>  
                            </div>  
                            <div className='font-black text-center uppercase leading-none text-[#4D1177] xl:text-[2.8rem] text-[2rem] lg:mb-auto mb-10'>  
                                Unleash the Power <br />of <span className='italic'>AI-Enabled</span><br /> Entertainment  
                            </div>  
                            <div className='text-center font-semibold text-[#4D1177]  lg:text-[#4D1177] italic leading-1 mt-4 text-[1rem] px-5 md:px-auto max-w-[500px] mx-auto'>  
                                ZKcandy, The AI-Enabled entertainment network. Experience immersive gaming, dynamic AI-driven entertainment, and seamless mobile Web3 access on ZKsync's Elastic Chain.  
                            </div>  
  
                            <a href='https://portal.zkcandy.io/' target='_blank' rel="noreferrer noopener" className="btn btn-dotted text-[1.2rem] text-center w-[200px]">  
                                Enter <br />Portal  
                            </a>  
                        </div>  
  
                        <a href='https://portal.zkcandy.io/' target='_blank' rel="noreferrer noopener" className='home-button'>  
                            <img src={homeButton} className='main' alt='Home Button' />  
                            <img src={homeButtonHover} className='hover' alt='Home Button Hover' />  
                        </a>  
                    </div>  
                </section>  
  
                <div className="bg-purple-space">  
                    <section id="partner">  
                        <div className="container max-w-[1200px] mx-auto text-white text-center pb-20 px-4">  
                            <div className="box-dot-container p-3 md:p-5 relative w-full flex flex-col justify-center items-center mb-5">  
  
                                <div className="bg-[#131313] rounded-2xl p-4 w-full border-2 border-black">  
                                    <div className="border-2 border-white rounded-2xl">  
                                        <Swiper  
                                            slidesPerView={1}  
                                            spaceBetween={30}  
                                            loop={true}  
                                            navigation={true}  
                                            modules={[Autoplay, Navigation]}  
                                            autoplay={{  
                                                delay: 6000,  
                                                disableOnInteraction: false,  
                                            }}  
                                            className="mySwiper"  
                                        >  
                                            <SwiperSlide>  
                                                <a className="animate-gradient-banner" href="https://app.galxe.com/quest/zkCandy/GCcmDt6FHi" target="_blank" rel="noopener noreferrer">  
                                                    <img src={swipeBanner3} alt="Galxe" className="rounded-2xl" />  
                                                </a>  
                                            </SwiperSlide>  
                                            <SwiperSlide>  
                                                <a className="animate-gradient-banner" href="https://kroswap.zkcandy.io/" target="_blank" rel="noopener noreferrer">  
                                                    <img src={swipeBanner1} alt="KRO Swap" className="rounded-2xl" />  
                                                </a>  
                                            </SwiperSlide>  
                                        </Swiper>  
                                    </div>  
                                </div>  
                            </div>  
                            <div className="flex gap-2 flex-col md:flex-row">  
                                <div className="box-dot-container p-10 relative w-full md:w-2/3 mb-5 md:mb-0 flex flex-col justify-center items-center">  
                                    <div className="dot absolute top-4 left-4"></div>  
                                    <div className="dot absolute top-4 right-4"></div>  
                                    <div className="dot absolute bottom-4 left-4"></div>  
                                    <div className="dot absolute bottom-4 right-4"></div>  
                                    <div className='text-stroke-shadow uppercase text-center font-black text-[1.5rem] md:text-[2rem] xl:text-[2.5rem] mb-5 leading-[1]'>AI-Enabled <br />Entertainment at <br /> your finger tips</div>  
                                    <div className="xl:text-[1.3rem]">Explore our mainnet, <br /> complete quests, and earn rewards.</div>  
  
  
                                    <div className="flex justify-center mt-5">  
                                        <a href='https://t.me/zkcandygame_bot' target='_blank' rel="noreferrer" className='bg-[#FD00CA] text-black font-black uppercase rounded-2xl border-black border-2 shadow-[0_10px_0_#390260] px-6 py-4 text-[1.2rem] xl:text-[1.5rem] relative hover:text-white transition duration-300  hover:shadow-[0_0px_8px_#FFF] hover:translate-y-[10px]'>  
                                            <div className="dot white absolute top-2 left-2 scale-50"></div>  
                                            <div className="dot white absolute bottom-2 left-2 scale-50"></div>  
                                            <div className="dot white absolute top-2 right-2 scale-50"></div>  
                                            <div className="dot white absolute bottom-2 right-2 scale-50"></div>  
                                            Enter Telegram <br /> Center  
                                        </a>  
                                    </div>  
                                </div>  
                                <div className="box-dot-container no-padding mb-5 md:mb-0  w-full md:w-1/3">  
                                    <img src={partnerGamecenter} alt="Gamecenter" className="p-3" />  
                                </div>  
                            </div>  
                        </div>  
                    </section>  
                </div>  
  
                <section id="all-aboard" className="overflow-hidden relative pb-5">  
  
                    <div className="container mx-auto relative">  
                        <a className="" href="https://app.layer3.xyz/campaigns/zkcandy" target="_blank" rel="noopener noreferrer">  
                            <img className='hover:scale-[1.1] cursor-pointer pt-10 transition-all duration-200' src={allAboardCandypoint} alt="All Aboard" />  
                        </a>  
  
                        <div className="relative mt-40 md:mt-60 z-10">  
                            <img src={allAboardMoon} className="absolute w-full lg:-top-[42%] xl:-top-[50%] -top-[28%]" alt="Moon" />  
                            <img src={allAboardHandLeft} className="absolute 2xl:w-[76%] 2xl:-left-[62%] 2xl:-top-[58%] xl:-left-[35%] xl:w-[50%] lg:-top-[24%] lg:-left-[30%] md:w-[46%] md:-top-[8%] w-[40%] -left-[32%]" alt="Console Hand Left" />  
                            <img src={allAboardHandRight} className="absolute 2xl:w-[76%] 2xl:-right-[62%] 2xl:-top-[58%] xl:-right-[35%] xl:w-[50%] lg:-top-[24%] lg:-right-[30%] md:-top-[8%] md:w-[46%] w-[40%] -right-[32%]" alt="Console Hand Right" />  
  
                            <div className={`all-aboard-tv relative lg:max-w-[75%] md:max-w-[80%] m-auto screen-${currentScreen} md:mt-10 mt-20`}>  
                                <div className="text-stroke-shadow py-4 uppercase text-white text-center font-black text-[2rem] md:text-[2.5rem] xl:text-[3rem] mb-5 leading-[1]" >  
                                    Get started with zkcandy!  
                                </div>  
                                <div className="screens relative z-10">  
                                    <div className="screen1">  
                                        <div className="screen-content">  
                                            <img src={allAboardScreen3} alt='Console Screen' />  
                                            <div className='absolute -translate-x-[50%] -translate-y-[50%] left-[50%] top-[50%] flex flex-col items-center'>  
                                                <div className='uppercase font-black xl:text-[3rem] md:text-[2rem] text-center leading-none'>Begin Your <br />Journey!</div>  
                                                <a href='https://portal.zkcandy.io/' target='_blank' rel="noreferrer" className='btn-dotted text-center flex-col justify-center leading-none mt-5 xl:text-[2rem] md:text-[1.5rem]'>  
                                                    <div className="left-dot"></div>  
                                                    <div className="right-dot"></div>  
                                                    <span className=''>Visit</span>  
                                                    <span className=''>Portal</span>  
                                                </a>  
                                            </div>  
                                        </div>  
                                    </div>  
                                </div>  
                            </div>  
                        </div>  
                    </div>  
                </section>  
  
                <section id="backed-by" className='bg-white py-10  -mt-[20rem] pt-[23rem] md:-mt-[35rem] md:pt-[35rem]'>  
                    <div className="container mx-auto">  
                        <div className='uppercase text-center lg:text-[4rem] md:text-[3rem] text-[2rem] text-primary font-black pt-10'>Backed By</div>  
  
                        <p className='w-[90%] max-w-[900px] mx-auto italic lg:text-[1.125rem] md:text-[1rem] text-[.9rem] font-medium text-center md:leading-8 leading-6 mb-20'>ZKcandy is backed by iCandy Interactive, Southeast Asia's largest game studio, with 500+ games, including 180 AAA titles, downloaded 300M+ times. We're powered by ZKsync technology, where simplified onboarding and negligible fees lay the ground for mass adoption.</p>  
  
                        <div className="grid md:grid-cols-2 grid-cols-1 items-center mb-10">  
                            <a href='https://zksync.io/' target='_blank' rel="noreferrer" className='btn-dotted-white md:w-[300px] w-[250px] h-[100px] md:h-[140px] lg:ms-auto lg:me-20 mx-auto md:mb-0 mb-5'>  
                                <div className="left-dot"></div>  
                                <div className="right-dot"></div>  
                                <img src={logoZksync} alt='ZKSync Logo' />  
                            </a>  
  
                            <div className='md:p-0 p-5 md:max-w-[500px]'>  
                                <h6 className='uppercase text-primary font-black mb-4 md:text-[2rem] text-[1.8rem] md:text-left text-center'>ZKSync</h6>  
                                <p className='italic lg:text-left text-justify font-medium md:pe-10 md:text-[1rem] text-[.9rem]'>  
                                    ZKsync is cutting-edge zero-knowledge (ZK) technology to scale Ethereum and bring crypto to the mainstream — reaching millions of developers and billions of people needing a technological solution for achieving progress and prosperity. Deeply rooted in its mission to advance personal freedom for all, the ZKsync blockchain network makes digital self-ownership universally available. It is trustless, secure, reliable, censorship-resistant, privacy-preserving, hyperscalable, accessible, and sovereign.  
                                </p>  
                            </div>  
                        </div>  
  
                        <div className="grid md:grid-cols-2 grid-cols-1 items-center pb-10">  
                            <a href='https://www.icandy.io/' target='_blank' rel="noreferrer" className='btn-dotted-white md:w-[300px] w-[250px] h-[100px] md:h-[140px] lg:ms-auto lg:me-20 mx-auto md:mb-0 mb-5'>  
                                <div className="left-dot"></div>  
                                <div className="right-dot"></div>  
                                <img className='' src={logoIcandy} alt='iCandy Logo' />  
                            </a>  
  
                            <div className='md:p-0 p-5 md:max-w-[500px]'>  
                                <h6 className="uppercase text-primary font-black mb-4 md:text-[2rem] text-[1.8rem] md:text-left text-center">  
                                    iCandy  
                                </h6>  
                                <p className='italic lg:text-left text-justify font-medium md:pe-10 md:text-[1rem] text-[.9rem]'>  
                                    iCandy Interactive Limited (iCandy) stands as one of the major game development studios in Southeast Asia and Oceania. As a publicly listed company on the ASX, iCandy boasts over 650 full-time employees, operating gaming studios in Germany, Thailand, Malaysia, Singapore, and Australia. Noteworthy shareholders in iCandy encompass Animoca Brands, Singtel, SK Telecom, AIS, Baidu, and others.  
                                </p>  
                            </div>  
                        </div>  
  
                        <div className="uppercase font-black text-primary text-center mt-20 text-[2rem] md:text-[2.8rem]">Supported By</div>  
                    </div>  
                    <div className='marquee pt-8'>  
                        <ul className='marquee__content'>  
                            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyWemix} alt='Wemix' /></li>  
                            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyAnimoca} alt='Animoca Brands' /></li>  
                            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbySpartan} alt='Spartan' /></li>  
                            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyPerlone} alt='Perlone Capital' /></li>  
                            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyPresto} alt='Presto' /></li>  
                            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyFlowdesk} alt='Flowdesk' /></li>  
                            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyLecca} alt='Lecca' /></li>  
                            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyEfficientFrontier} alt='Efficient Frontier' /></li>  
                            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyPrometheuz} alt='Prometheuz' /></li>  
                        </ul>  
                        <ul className='marquee__content' aria-hidden='true'>  
                            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyWemix} alt='Wemix' /></li>  
                            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyAnimoca} alt='Animoca Brands' /></li>  
                            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbySpartan} alt='Spartan' /></li>  
                            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyPerlone} alt='Perlone Capital' /></li>  
                            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyPresto} alt='Presto' /></li>  
                            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyFlowdesk} alt='Flowdesk' /></li>  
                            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyLecca} alt='Lecca' /></li>  
                            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyEfficientFrontier} alt='Efficient Frontier' /></li>  
                            <li><img className='xl:w-[150px] w-[100px] me-10' src={supportbyPrometheuz} alt='Prometheuz' /></li>  
                        </ul>  
                    </div>  
                </section>  
  
                <section id="litepaper" className="relative">  
                    <div className="max-w-[2000px] mx-auto relative">  
                        <img className="absolute md:top-[-40px] top-[-20px] w-full" src={litepaperDashboardTop} alt="Litepaper Dashboard" />  
  
                        <div className="flex justify-center items-center absolute -translate-y-1/2 top-[29%] -translate-x-1/2 left-1/2 z-10">  
                            <div className="litepaper-text 2xl:max-w-[650px] xl:max-w-[450px] lg:max-w-[400px] md:max-w-[300px] max-w-[160px] relative flex flex-col items-center justify-center">  
                                <img src={litepaperMoon} className="w-[80px] md:w-[140px] lg:w-[210px] xl:w-[250px] absolute" alt="Litepaper" />  
                                <img src={litepaperTextbox} className="relative" alt="Litepaper" />  
                            </div>  
                        </div>  
                        <div className="relative xl:pt-60 pt-40">  
                            <img src={litepaperDashboardBottom} className="w-full" alt="Litepaper Dashboard" />  
                            <a href='https://litepaper.zkcandy.io/' target='_blank' rel="noreferrer" className="litepaper-button absolute bottom-[15%] md:bottom-[19.5%] lg:bottom-[21.5%] xl:bottom-[20%] 2xl:bottom-[22%] left-[40.7%] w-[17%] -translate-x-1/2">  
                                <img src={litepaperButton1} alt="Litepaper" className="magenta absolute top-0 z-2 w-full" />  
                                <img src={litepaperButton1Hover} alt="Litepaper" className="w-full" />  
                            </a>  
                            <a href='https://docs.zkcandyapi.com/' target='_blank' rel="noreferrer" className="litepaper-button absolute bottom-[15%] md:bottom-[19.5%] lg:bottom-[21.5%] xl:bottom-[20%] 2xl:bottom-[22%] right-[24%] w-[17%] -translate-x-1/2">  
                                <img src={litepaperButton2} alt="Litepaper" className="magenta absolute top-0 z-2 w-full" />  
                                <img src={litepaperButton2Hover} alt="Litepaper" className="w-full" />  
                            </a>  
                        </div>  
                    </div>  
                </section>  
  
                <section id="stay-connected" className='flex'>  
                    <div className="container mx-auto flex flex-col justify-center items-center">  
                        <div className='uppercase text-white lg:text-[3.5rem] md:text-[2.5rem] text-[1.5rem] text-center font-black'>Stay Connected With Us</div>  
                        <div className='text-white lg:text-[1.1rem] md:text-[1rem] text-[.9rem] md:px-0 px-6 italic font-medium text-center mt-4 uppercase'>Get ZKcandy's latest ecosystem updates delivered straight to your mailbox.</div>  
  
                        <div className="social grid md:grid-cols-4 grid-cols-2 md:gap-6 gap-10 mt-10">  
                            {social.map((item, index) => (  
                                <a href={item.link} key={index} target='_blank' rel="noreferrer">  
                                    <img src={item.img} className='lg:w-[64px] md:w-[48px] w-[64px]' alt='Social Media' />  
                                </a>  
                            ))}  
                        </div>  
                    </div>  
                </section>  
            </main>  
            <footer>  
  
            </footer>  
        </div>  
    );  
}